module.exports = __webpack_public_path__ + "img/video.f35922c8.jpeg";